"use client";

import { Zoom, Fab, useScrollTrigger } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function BackToTop({ scrollRef }) {
  const trigger = useScrollTrigger({
    target: scrollRef?.current || undefined,
    disableHysteresis: true,
    threshold: 300,
  });

  const handleClick = () => {
    scrollRef.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Zoom in={trigger}>
      <Fab
        onClick={handleClick}
        color="primary"
        size="medium"
        sx={{
          position: "absolute",
          bottom: 24,
          right: 24,
          zIndex: 7500,
        }}
        aria-label="Back to top"
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </Zoom>
  );
}
